import { SerializedData, Store } from "bernie-core";
import { action, observable } from "mobx";
import { Logger } from "bernie-logger";

/**
 * Store that contains Flex Microservice model responses
 * returned by compositor in Map, addressible by module id
 */
export class FlexModuleStore extends Store {
  @observable
  public modelMap: Map<string, object>;

  private modelMapAsObject: object;

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
    this.modelMap = new Map();
  }

  public hydrate(data: SerializedData): void {
    // Map isn't serializable: convert modelMapAsObject back to Map
    /* istanbul ignore else */
    if (data.modelMapAsObject) {
      Object.getOwnPropertyNames(data.modelMapAsObject).forEach((key) => {
        this.modelMap.set(key, data.modelMapAsObject[key]);
      });
    }
  }

  @action
  public updateModelMap(id: string, model: object) {
    this.modelMap.set(id, model);
  }

  public toJSON(): SerializedData {
    // Map isn't serializable: convert modelMap to modelMapAsObject
    this.modelMapAsObject = {};
    this.modelMap.forEach((value, key) => (this.modelMapAsObject[key] = value));

    // TODO: add "modelMapAsObject" to list until composition can be removed from CompositionStore serialized state
    // having both composition and modelMapAsObject duplicates data, inflating the size of the HTML response
    return super.toJSON(["modelMap", "modelMapAsObject"]);
  }
}
